module.exports = __webpack_public_path__ + "static/media/logo-white-reversed.a8445b97.svg";